import React, { useState } from 'react'
import PropTypes from 'prop-types'

import add from 'images/add.svg'
import disabledAddIcon from 'images/disabled-add-icon.svg'
import screenType from 'component/menuMission/screenType'
import Form from 'component/utils/Form'
import Modal from 'component/Modal/GenericModal'
import TextField from 'component/TextField'

const FIELDS = ['params', 'type']

const EditModal = ({
  closeModal,
  fields,
  initialValues,
  setValueToField,
  submit,
  translate,
  values,
  values: { params, type = screenType.CREATE_PERSONAL_PROFILE_TYPE },
}) => {
  const [initialDsJustification] = useState(
    initialValues.params[0].dsJustification
  )

  const disableButton = () =>
    thereAreEmptyFields() ||
    params[0].dsJustification === initialDsJustification

  const thereAreEmptyFields = () => !params.some((j) => j)

  const hasAnyEmptyField = () => params.some((j) => !j.dsJustification)

  const createField = (item, i) => {
    const dsJustification = item.dsJustification.trim()

    return (
      <div className='w-100' key={i}>
        <TextField
          {...fields.params.input}
          className='form-control no-change-color'
          fill
          label={translate(
            dsJustification
              ? 'linear.conference.justification.modal.new.placeholder'
              : 'linear.conference.justification.modal.new.label'
          )}
          maxLength={200}
          onChange={(event) => {
            const newParams = [...params]

            item.dsJustification = event.target.value.trim()

            setValueToField(fields.params.input.name, newParams)
          }}
          placeholder={translate(
            'linear.conference.justification.modal.new.placeholder'
          )}
          required
          value={dsJustification}
        />
      </div>
    )
  }

  const onConfirm = () => {
    const params = removeFieldsWithoutValue()
    submit(params)
  }

  const removeFieldsWithoutValue = () =>
    values.params.filter((field) => field.dsJustification !== '')

  return (
    <Modal
      buttonClass='half-w'
      cancelButtonText={translate('button.cancel')}
      center={false}
      confirmButtonText={translate(
        type === screenType.CREATE_PERSONAL_PROFILE_TYPE ||
          type === screenType.CREATE_MISSION_PROFILE_TYPE
          ? 'register_button'
          : 'save_button_label'
      )}
      isConfirmButtonDisabled={disableButton()}
      isOpen
      onCloseModal={closeModal}
      onConfirm={onConfirm}
      size='md'
      title={translate(`linear.conference.justification.modal.title.${type}`)}
      disabledBgClickClosing
    >
      {params.map(createField)}

      {type === screenType.CREATE_PERSONAL_PROFILE_TYPE && (
        <div
          className={hasAnyEmptyField() ? 'add-item-disabled' : 'add-item'}
          onClick={
            hasAnyEmptyField()
              ? () => {}
              : () =>
                  setValueToField(fields.params.input.name, [
                    ...params,
                    { dsJustification: '', inInactive: 0 },
                  ])
          }
        >
          <img src={hasAnyEmptyField() ? disabledAddIcon : add} />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div>
            <span>
              {translate('linear.conference.justification.modal.new.more')}
            </span>
          </div>
        </div>
      )}
    </Modal>
  )
}

EditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(EditModal)

export { EditModal }
